import React, {useContext,useState,useEffect} from "react";
import { useLocation } from 'react-router-dom'
import Context from '../context/context';

const config = require("../_helpers/configServizi");



export default function SignupForm(props) {

    const [page, setPage] = useState(1)
    const [setOfPages,setSetOfPages] = useState()
    const [endPage,setEndPage] = useState()

    useEffect(() => {
        

        printPagination()
        
       }, [page,props.totalProfiles]);
       
       
    // Sincronizza lo stato interno con la pagina passata dal genitore.
    // Necessario perché al remount (es. back dal profilo) il genitore
    // conosce già la pagina corretta, ma questo stato parte sempre da 1.
    useEffect(() => {
        if(props.currentPage && props.currentPage !== page) {
            setPage(props.currentPage);
        }
    }, [props.currentPage]);


    function printPagination() {
        
        var set=[]
        const pagesPerSet = 5;
     
        var currentSet = Math.ceil(page / pagesPerSet)
        currentSet = currentSet - 1

        setEndPage(Math.ceil(props.totalProfiles / pagesPerSet))
        //console.log("profili totali",props.totalProfiles)
        //console.log("END",Math.ceil(props.totalProfiles / pagesPerSet))
   
        for (let i = (currentSet*pagesPerSet)+1; i < (currentSet*pagesPerSet)+6; i++) {
        
            set.push(i)
        }

        setSetOfPages(set)
        
    }
	

    return(<>
        
            <div className="column large-12">
            <nav className="pgn">
                <ul>


                {props.currentPage && (
                    <>
                    {props.currentPage == 1  ? (
                       <li>
                         <button className="pgn__prev" onClick={()=>{return null}}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                        >
                            <path d="M12.707 17.293L8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z" />
                        </svg>
                        </button>
                       </li>
                    ):(
                        <li>
                        <button className="pgn__prev" onClick={()=>{props.onChangePage((page -1 ));setPage(page - 1)}}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                        >
                            <path d="M12.707 17.293L8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z" />
                        </svg>
                        </button>
                    </li>
                    )}
                    </>    
               )}


               
                { setOfPages ? (
                    setOfPages.map((obj,index) => { return (<>
                        {props.currentPage == (obj) ? (
                            <li className="current">
                                <a className="pgn__num" onClick={()=>{props.onChangePage(obj);setPage(obj)}}>
                                {obj}
                                </a>
                            </li>
                        ) : (
                            <li>
                                <a className="pgn__num" onClick={()=>{props.onChangePage(obj);setPage(obj)}}>
                                {obj}
                                </a>
                            </li>
                        )}
                        
                    </>) })

                    ) : null
                }
               
               
               {endPage && (
                    <>
                    {endPage == page  ? (
                        <li>
                             <button className="pgn__next" aria-disabled={true}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                            >
                                <path d="M11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" />
                            </svg>
                            </button>
                        </li>
                    ):(
                        <li>
                            <button className="pgn__next"  onClick={()=>{props.onChangePage((page + 1));setPage(page + 1)}}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                            >
                                <path d="M11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" />
                            </svg>
                            </button>
                        </li>
                    )}
                    </>    
               )}
               
                </ul>
            </nav>{" "}
            {/* end pgn */}
            </div>{" "}
            {/* end column */}
        
        {/* end row */}
        </>
    )
	
}